import $ from 'jquery';
import Foundation from 'foundation-sites';
import {sgyRegulations} from "../lib/sgyCore/sgyRegulations.js";
import {sgyConsumer} from "../lib/sgyCore/sgyConsumer.js";
// this needs a require for consistency with API core
import taxationCore from "../lib/sgyCore/sgyTaxation.js";
import ga4 from '../lib/ga-helper.js'
$(function() {
    let moneyForm = $(".js-calc-extra-money-form");
    let steps = $(".js-calc-extra-money-step");
    let stepIndex = $(".js-calc-extra-money-index");
    let stepNext = $(".js-calc-extra-money-next");
    let stepBack = $(".js-calc-extra-money-back");
    let restart = $('.js-calc-extra-money-restart');
    let coffeeCount = $('.js-calc-extra-money-coffee-count');
    let coffee = $('.js-calc-extra-money-coffee');
    let lunchCount = $('.js-calc-extra-money-lunch-count');
    let lunch = $('.js-calc-extra-money-lunch');
    let savings = $('.js-calc-extra-money-savings');
    let extras = $('.js-calc-extra-money-extras');
    let weekTotal = $('.js-calc-extra-money-total-week');
    let yearTotal = $('.js-calc-extra-money-total-year');
    let salary = $('.js-calc-extra-money-salary');
    let age = $('.js-calc-extra-money-age');
    let contribution = $('.js-calc-extra-money-cont');
    let taxPanel = $('.js-calc-extra-money-panel-tax');
    let taxBefore = $('.js-calc-extra-money-before-tax');
    let taxAfter = $('.js-calc-extra-money-after-tax');
    let taxTotal = $('.js-calc-extra-money-total-tax');
    let introAfter = $('.js-result-intro-after');
    let introBefore = $('.js-result-intro-before');
    let introBoth = $('.js-result-intro-both');
    let panelAfter = $('.js-result-panel-after');
    let panelBefore = $('.js-result-panel-before');
    let panelBoth = $('.js-result-panel-both');
    let assumptions = $('.js-calc-extra-money-assumptions');
    let laststep = 3;
    const $memberLoginBtn = $('.js-member-login-btn'),
    $startAddingBtn = $('.js-start-adding-btn')
    $startAddingBtn.on('click', function(){ ga4.trackEvnt('calculator_find_extra_money', {'conversion_type': 'start adding'}) })
    $memberLoginBtn.on('click', function(){ ga4.trackEvnt('calculator_find_extra_money', {'conversion_type': 'login to you member-online account'}) })
    const FindExtraMoney = {
        FoundationExtraValidator: {
            init: function() {
                new Foundation.Abide(moneyForm);
            }
        },
        Inputs: {
            init: function() {
                age.on('blur', function() {
                    const value = $(this).val()
                    if (value !== "") {
                        let from = parseInt($(this)[0].getAttribute('data-min'), 10),
                            to = parseInt($(this)[0].getAttribute('data-max'), 10),
                            val = parseInt($(this).val().reverseFormatMoney(0), 10);
                        if (val < from) $(this).val(from);
                        if (val > to) $(this).val(to);
                    }
                    let bracketed = null
                    if (value <= 24) {
                        bracketed = "18-24";
                    } else if (value >= 25 && value <= 34) {
                        bracketed = "25-34";
                    } else if (value >= 35 && value <= 44) {
                        bracketed = "35-44";
                    } else if (value >= 45 && value <= 54) {
                        bracketed = "45-54";
                    } else if (value >= 55 && value <= 64) {
                        bracketed = "55-64";
                    } else {
                        bracketed = "65+";
                    }
                    ga4.trackEvnt('calculator_find_extra_money', {'user_age': bracketed})
                });
                salary.on('blur', function() {
                    const value = $(this).val()
                    if (value !== "") {
                        let from = parseInt($(this)[0].getAttribute('data-min'), 10),
                            to = parseInt($(this)[0].getAttribute('data-max'), 10),
                            val = parseInt($(this).val().reverseFormatMoney(0), 10);
                        if (val < from) $(this).val(from);
                        if (val > to) $(this).val(to);
                    }
                    let bracketed = null
                    if (value <= 48000) {
                        bracketed = "Low income";
                    } else if (value >= 48001 && value <= 90000) {
                        bracketed = "Medium income";
                    } else {
                        bracketed = "High income";
                    }
                    ga4.trackEvnt('calculator_find_extra_money', {'user_income': bracketed})
                });
                extras.on('blur', function() {
                    if ($(this).val() !== "") {
                        let from = parseInt($(this)[0].getAttribute('data-min'), 10),
                            to = parseInt($(this)[0].getAttribute('data-max'), 10),
                            val = parseInt($(this).val().reverseFormatMoney(0), 10);
                        if (val < from) $(this).val(from);
                        if (val > to) $(this).val(to);
                    }
                });
                coffeeCount.on('blur', function() {
                    if ($(this).val() !== "") {
                        let from = parseInt($(this)[0].getAttribute('data-min'), 10),
                            to = parseInt($(this)[0].getAttribute('data-max'), 10),
                            val = parseInt($(this).val().reverseFormatMoney(0), 10);
                        if (val < from) $(this).val(from);
                        if (val > to) $(this).val(to);
                        let num = parseInt($(this).val()) * 4;
                        coffee.val(num).blur();
                    } else {
                        coffee.val(0).blur();
                    }
                });
                lunchCount.on('blur', function() {
                    if ($(this).val() !== "") {
                        let from = parseInt($(this)[0].getAttribute('data-min'), 10),
                            to = parseInt($(this)[0].getAttribute('data-max'), 10),
                            val = parseInt($(this).val().reverseFormatMoney(0), 10);
                        if (val < from) $(this).val(from);
                        if (val > to) $(this).val(to);
                        let num = parseInt($(this).val()) * 10;
                        lunch.val(num).blur();
                    } else {
                        lunch.val(0).blur();
                    }
                });
                moneyForm.find('input.js-format-money').on('blur', function() {
                    if ($(this).val() !== '') {
                        let num = $(this).val().reverseFormatMoney() //we remove dollar if dollar
                        num = parseInt(num).formatMoney(0);
                        $(this).val(num);
                    }
                    FindExtraMoney.Calculations.extras();
                });
            }
        },
        Form: {
            validateStep: function(step) {
                // get currentStep
                let currentStep = steps.filter("[data-step='" + step + "']");
                moneyForm.foundation('validateForm');
                if (currentStep.find(':input[data-invalid]').length == 0) return true;
                else {
                    stepIndex.filter("[data-step='" + step + "']").addClass('calc-nav__item--error');
                    return false;
                }
            },
            clearValidation: function(step) {
                let nextStep = steps.filter("[data-step='" + step + "']");
                //moneyForm.foundation('resetForm');
                nextStep.find(':input[data-invalid]').each(function() {
                    // remove errors in next step
                    moneyForm.foundation('removeErrorClasses', $(this));
                });
            },
            showStep: function(step) {
                steps.removeClass('js-show-step').addClass('js-hide-step');
                steps.filter("[data-step='" + step + "']").removeClass('js-hide-step').addClass('js-show-step');
                $("html, body").animate({
                    scrollTop: moneyForm.offset().top - 100,
                }, 200, function() {
                    //force the padding to be correct
                    window.setTimeout(function() {
                        $('header').addClass('shrink');
                        //console.log('srhink');
                    }, 200);
                });
            },
            updateIndex: function(step) {
                stepIndex.removeClass('calc-nav__item--correct').removeClass('calc-nav__item--current').removeClass('calc-nav__item--error');
                stepIndex.each(function() {
                    let index = $(this).data('step');
                    if (index == step) {
                        if (step == laststep) $(this).addClass('calc-nav__item--correct');
                        else $(this).addClass('calc-nav__item--current');
                    }
                    if (index < step) $(this).addClass('calc-nav__item--correct');
                });
            }
        },
        Navigate: {
            init: function() {
                stepBack.on('click', function(e) {
                    e.preventDefault();
                    let step = $(this).data('gostep');
                    FindExtraMoney.Navigate.moveBack(step);
                });
                stepNext.on('click', function(e) {
                    e.preventDefault();
                    let step = $(this).data('gostep');
                    FindExtraMoney.Navigate.moveForward(step);
                });
                restart.on('click', function() {
                    window.location.reload();
                });
            },
            moveBack: function(step) {
                FindExtraMoney.GA.track('Find Extra Money For Super', 'Navigation', 'Back to step ' + step);
                FindExtraMoney.GA.trackPistol('calculator_use','Top up your super calc',step);
                switch (step) {
                    case 1:
                        // checks to move to step 1
                        if (true) {
                            FindExtraMoney.Form.showStep(1);
                            FindExtraMoney.Form.updateIndex(1);
                        } else {
                            return false;
                        }
                        break;
                    case 2:
                        // checks to move to step 2
                        if (true) {
                            FindExtraMoney.Form.showStep(2);
                            FindExtraMoney.Form.updateIndex(2);
                        } else {
                            return false;
                        }
                        break;
                    default:
                        return false;
                }
            },
            moveForward: function(step) {
                switch (step) {
                    case 2:
                        FindExtraMoney.GA.track('Find Extra Money For Super', 'Navigation', 'Next');
                        FindExtraMoney.GA.trackPistol('calculator_use','Top up your super calc',2);
                        // checks to move to step 2
                        if (FindExtraMoney.Form.validateStep(1)) {
                            contribution.val(yearTotal.html());
                            FindExtraMoney.Calculations.contribution();
                            FindExtraMoney.Form.clearValidation(2);
                            FindExtraMoney.Form.showStep(2);
                            FindExtraMoney.Form.updateIndex(2);
                        } else {
                            return false;
                        }
                        break;
                    case 3:
                        FindExtraMoney.GA.track('Find Extra Money For Super', 'Navigation', 'Take action (completion)');
                        FindExtraMoney.GA.trackPistol('calculator_complete','Top up your super calc',3);
                        // checks to move to step 3
                        if (FindExtraMoney.Form.validateStep(2)) {
                            FindExtraMoney.Form.clearValidation(3);
                            FindExtraMoney.Form.showStep(3);
                            FindExtraMoney.Form.updateIndex(3);
                        } else {
                            return false;
                        }
                        break;
                    default:
                        return false;
                }
            }
        },
        Calculations: {
            extras: function() {
                let tot = 0;
                savings.each(function() {
                    let num = parseInt($(this).val().reverseFormatMoney());
                    if (isNaN(num)) num = 0;
                    tot += num;
                });
                weekTotal.val(parseInt(tot).formatMoney(0));
                tot = tot * 52;
                yearTotal.html(parseInt(tot).formatMoney(0));
                if (tot !== 0) {
                    extras.removeAttr('required');
                    moneyForm.foundation('removeErrorClasses', extras);
                } else {
                    extras.attr('required', 'required');
                }
            },
            contribution: function() {
                sgyConsumer.age = age.val();
                sgyConsumer.startSal = parseInt(salary.val().reverseFormatMoney());
                let unallocated_contribution = parseInt(contribution.val().reverseFormatMoney());
                let results = taxationCore.sgyTaxation(sgyRegulations,sgyConsumer,unallocated_contribution);
                // console.log(results);
                let afterExtra = Math.round(results.contributions.after);
                let beforeExtra = Math.round(results.contributions.before);
                // after Help is government co-contribution
                let afterHelp = Math.round(results.post_contributions.co_contribution);
                // before Help is the Tax savings
                let beforeHelp = Math.round(results.differences.income_tax + results.differences.medicare_levy + results.differences.lito);
                let totalExtra = Math.round(afterExtra + beforeExtra);
                let totalHelp = Math.round(afterHelp + beforeHelp);
                //hide intros
                introAfter.hide();
                introBefore.hide();
                introBoth.hide();
                //hide panels
                panelAfter.hide();
                panelBefore.hide();
                panelBoth.hide();
                //hide rows
                taxAfter.hide();
                taxBefore.hide();
                //determine path
                if (afterExtra !== 0 && beforeExtra !== 0) {
                    // both before and after
                    introBoth.show();
                    panelBoth.show();
                    taxAfter.show();
                    taxBefore.show();
                } else if (afterExtra !== 0) {
                    // after contribution
                    introAfter.show();
                    panelAfter.show();
                    taxAfter.show();
                } else if (beforeExtra !== 0) {
                    // before contribution
                    introBefore.show();
                    panelBefore.show();
                    taxBefore.show();
                }
                //set the rows regardless
                taxAfter.find('.js-extra').html(afterExtra.formatMoney(0));
                taxAfter.find('.js-help').html(afterHelp.formatMoney(0));
                taxBefore.find('.js-extra').html(beforeExtra.formatMoney(0));
                taxBefore.find('.js-help').html(beforeHelp.formatMoney(0));
                taxTotal.find('.js-extra').html(totalExtra.formatMoney(0));
                taxTotal.find('.js-help').html(totalHelp.formatMoney(0));
            }
        },
        GA: {
            init: function() {
                window.setTimeout(function() {
                    FindExtraMoney.GA.track('Find Extra Money For Super', 'Step', 'Start');
                }, 10000);
                steps.filter("[data-step=1]").find('input').on('blur', function() {
                    FindExtraMoney.GA.track('Find Extra Money For Super', 'Step 1', $(this).attr('name'));
                });
                $('.ga-nomoney-calc-assumption-action').on('click', function() {
                    FindExtraMoney.GA.track('Find Extra Money For Super', 'Assumptions', $(this).data('action'));
                });
                FindExtraMoney.GA.trackPistol('calculator_use','Top up your super calc',1);
            },
            track: function(category, action, opt_label, opt_value) {
                ga('send', 'event', category, action, opt_label, opt_value);
            },
            trackPistol(evtype, name, step) {
                window.dataLayer.push({
                  event: evtype,
                  calculator_name: name,
                  step_number: step,
                  step_name: "Step "+step,
                 });
            }
        }
    };
    const App = {
        Initialize: function(obj) {
            $.each(obj, function(key, value) {
                if (value) {
                    if (key == "init" && typeof value == "function") {
                        value.call(obj);
                    } else if (typeof value == "object") {
                        App.Initialize(value);
                    }
                }
            });
        }
    };
    $(document).ready(function() {
        App.Initialize(FindExtraMoney);
    });
    Number.prototype.formatMoney = function(c, d, t) {
        let n = this,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;
        return '$' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };
    String.prototype.reverseFormatMoney = function() {
        let n = this;
        return n.replace(/[^0-9]/g, '');
    };
    let _gaq = [];
});
//<!-- Copyright © Spark Green Pty Ltd Australia -->
